import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import { hasRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import { addQueryWithReplace } from 'Helpers/Query';
import Content from './Content';

const useStyles = buildUseStyles('NonAcatConfirmationStep', () => ({
  root: {},
}));

const NonAcatConfirmationStep = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { loadPageContentLink } = usePageContentContext();
  const history = useHistory();

  const activationTest = hasRelationship(resource, fr.relationships.activationTest.name);

  const onNext = async () => {
    if (hasRelationship(resource, fr.relationships.redirect.name)) {
      addQueryWithReplace({ tab: 'withdrawals-transfers-tab' });
      await loadPageContentLink(resource.relationship(fr.relationships.redirect.name).link('related'));
    } else {
      history.push('/');
    }
  };

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={Content}
      LayoutProps={{
        resource,
      }}
      resource={resource}
      primaryActionLabel={resource.attr('primaryActionText')}
      metaOverrideSet={BaseOverride}
      onNext={!activationTest && onNext}
      hideBack
      onClose={!activationTest && onClose}
    />
  );
};

NonAcatConfirmationStep.defaultProps = {
  className: '',
};

NonAcatConfirmationStep.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default NonAcatConfirmationStep;
